module.exports = __webpack_public_path__ + "static/img/vEight2.fb4d31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vEight2.png
// module id = Sa8G
// module chunks = 2